import { render, staticRenderFns } from "./CustTelChange.vue?vue&type=template&id=a8830cec&scoped=true"
import script from "./CustTelChange.vue?vue&type=script&lang=js"
export * from "./CustTelChange.vue?vue&type=script&lang=js"
import style0 from "./CustTelChange.vue?vue&type=style&index=0&id=a8830cec&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a8830cec",
  null
  
)

export default component.exports